export default [
  {
    label: '温泉施設隣接',
    value: 'bath_hotspring',
  },
  {
    label: 'シャワー・お風呂あり',
    value: 'bath_room',
  },
];
